/**
 * Fallback language is English. This is a legal requirement to ensure that notices
 * appear in the language most likely to be used, as well as in English.
 */
export const FALLBACK_LANGUAGE = 'en';

export type I18nTranslationKeys = 'noticeText' | 'otherSitesLinkCaption';
export type I18nTranslations = Record<I18nTranslationKeys, string>;

/**
 * Text parts that add up to a Notice Layer text paragraph
 */
export interface NoticeText {
  language: string; // created from code
  noticeText: string; // from i18n
  countrySite: string; // created from code
  otherSitesLinkCaption: string; // from i18n
  otherSitesLinkUrl: string; // created from code
}

export interface FeatureAppState {
  readonly primaryLanguage: string;
  readonly fallbackLanguage: string;
  readonly translations: I18nTranslations;
  readonly fallbackTranslations: I18nTranslations;
  readonly redirectTagPath: string;
}
